import { useWeb3React } from '@web3-react/core'
import { Chain } from 'graphql/data/__generated__/types-and-hooks'
import { chainIdToBackendName } from 'graphql/data/util'
import { usePrevious } from 'utilities/src/react/hooks'

export const useOnGlobalChainSwitch = (callback: (chain: Chain) => void) => {
  const { chainId } = useWeb3React()
  if (chainId !== usePrevious(chainId) && chainId) {
    const chainName = chainIdToBackendName(chainId)
    callback(chainName)
  }
}
